import { ReactElement } from 'react';
import { USER_ROLES } from '../../constants';
import RestrictedRoute from '../RestrictedRoute';
import Prototype1Page from './prototype-1/Prototype1Page';
import Prototype2Page from './prototype-2/Prototype2Page';
import Prototype3Page from './prototype-3/Prototype3Page';
import Prototype4Page from './prototype-4/Prototype4Page';
import { prototypeNavLinks } from './navLinks';
import type { PrototypeNavLink } from './navLinks';

interface PrototypeRoute {
  path: string;
  element: ReactElement;
}

const wrap = (el: ReactElement, allowedRoles: string[] = [USER_ROLES.SUPER_ADMIN]) => (
  <RestrictedRoute allowedRoles={allowedRoles}>{el}</RestrictedRoute>
);

const prototypeRoutes: PrototypeRoute[] = [
  { path: '/prototypes/1', element: wrap(<Prototype1Page />) },
  { path: '/prototypes/2', element: wrap(<Prototype2Page />) },
  { path: '/prototypes/3', element: wrap(<Prototype3Page />) },
  { path: '/prototypes/4-sql', element: wrap(<Prototype4Page />) },
];

export { prototypeRoutes, prototypeNavLinks };
export type { PrototypeRoute, PrototypeNavLink };
